import { useContext } from 'react';

import { UserContext } from './AuthUserContext';
import { User } from './types';

export function useUserInfo(): User | undefined {
  const userInfo = useContext(UserContext);

  if (userInfo) {
    return userInfo.user;
  }

  throw new Error('useUserInfo must be used inside UserContext Provider. User information not found.');
}
